var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilOutline = function SvgPencilOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m20.268 3.732.53-.53zM6.5 21.035v.75a.75.75 0 0 0 .53-.22zm-3.5 0h-.75c0 .415.336.75.75.75zm0-3.57-.53-.53a.75.75 0 0 0-.22.53zM17.263 4.262a1.75 1.75 0 0 1 2.474 0l1.061-1.061a3.25 3.25 0 0 0-4.596 0zm2.474 0a1.75 1.75 0 0 1 0 2.474l1.061 1.061a3.25 3.25 0 0 0 0-4.596zm0 2.474L5.97 20.505l1.06 1.06L20.798 7.799zM6.5 20.286H3v1.5h3.5zm9.702-17.084L2.47 16.934l1.06 1.06L17.263 4.264zM2.25 17.464v3.572h1.5v-3.572zM14.702 5.763l3.535 3.535 1.061-1.06-3.535-3.536z"
  })));
};
export default SvgPencilOutline;